import List from './list'
import Detail from './detail'

export default function(prefix, app) {
  return app
    .useRoute(`${prefix}/list/detail/:id/:type`, Detail)
    .useRoute(`${prefix}/list`, List)
}
